// src/components/Header.js
import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Database } from 'lucide-react';
const HeaderSign = () => {
  return (
    <header className="bg-white bg-opacity-70 shadow-sm border-b fixed w-full z-10 animate-fadeIn backdrop-blur-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          <div href="/" className="flex items-center">
            <Link to="/" className="w-10 h-10 rounded-full mr-3 overflow-hidden flex items-center justify-center bg-blue-600">

              <img src="/logo.jpg" alt="Logo" className="w-full h-full object-cover" />
            </Link>
            <Link to="/" className="text-xl font-bold text-gray-900">
              <span>DealGrid</span>
            </Link>
          </div>
          <div className="flex space-x-4">
            {/* <Link to="/login" className="bg-gray-200 text-blue-600 px-6 py-2 rounded-lg hover:bg-gray-300 hover:scale-105 transition-transform">
              Log In
            </Link> */}

            <Link to="/" className="bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 hover:scale-105 transition-transform">
              Home
            </Link>



          </div>
        </div>
      </div>
    </header>
  );
};

export default HeaderSign;